export default __webpack_public_path__ + "static/media/4.86544ce4.png";